var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.784,
    height: 53,
    viewBox: "0 0 41.784 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(-11.5 -6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9724",
    "data-name": "Path 9724",
    d: "M52.784,19.235V54.922A4.078,4.078,0,0,1,48.706,59H16.078A4.078,4.078,0,0,1,12,54.922V11.078A4.078,4.078,0,0,1,16.078,7H44.627l8.157,8.157H46.667a2.039,2.039,0,0,1-2.039-2.039V7",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#0c90a9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "note-pencil",
    transform: "translate(23.989 24.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9715",
    "data-name": "Path 9715",
    d: "M262.131,297.713l-2.73-2.73a.555.555,0,0,0-.784,0l-2.047,2.047h0l-6.142,6.142a.555.555,0,0,0-.162.392v2.73a.555.555,0,0,0,.555.555h2.73a.555.555,0,0,0,.392-.162l8.189-8.189A.555.555,0,0,0,262.131,297.713Zm-8.811,8.027h-1.945v-1.945l5.587-5.587,1.945,1.945Zm6.372-6.371-1.945-1.945,1.263-1.263,1.945,1.945Z",
    transform: "translate(-245.489 -294.821)",
    fill: "#0c90a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9716",
    "data-name": "Path 9716",
    d: "M196.927,311.488a.555.555,0,0,0-.555.555v7.507a.128.128,0,0,1-.128.128H182.6a.128.128,0,0,1-.128-.128V305.9a.128.128,0,0,1,.128-.128H190.1a.555.555,0,0,0,0-1.109H182.6a1.239,1.239,0,0,0-1.237,1.237v13.648a1.238,1.238,0,0,0,1.237,1.237h13.648a1.238,1.238,0,0,0,1.237-1.237v-7.507A.555.555,0,0,0,196.927,311.488Z",
    transform: "translate(-181.359 -303.982)",
    fill: "#0c90a9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBig);
export default __webpack_public_path__ + "static/media/edit-big.719172c075a2686e6d03a4c0856ac0b3.svg";
export { ForwardRef as ReactComponent };